import React, { useCallback, useState, useEffect } from 'react';

import {
  Box,
  Input,
  FormControl,
  FormLabel,
  FormErrorMessage
} from '@chakra-ui/react';

const FieldComponent = ({
  fieldId,
  dataId,
  submitAttempted,
  defaultPlaceholder,
  fieldLabel,
  fieldValue,
  required,
  errorMessage,
  noFileSelectedMessage = `No file selected.`,
  onChange = (v) => {},
  onReady = () => {}
}) => {
  const [isError, setIsError] = useState(required);
  const [filesSelected, setFilesSelected] = useState(null);
  const [accepted, setAccepted] = useState(null);
  const [allowMulti, setAllowMulti] = useState(false);

  const handleOnChange = useCallback(
    (filesRef) => {
      const [fileRef] = filesRef;

      const fileIsNullOrUndefined =
        typeof fileRef === `undefined` || fileRef === null;

      const isEmpty = required === true && fileIsNullOrUndefined === true;

      const hasExceeded =
        fileIsNullOrUndefined === false && fileRef.size > 10485760; // 10mb

      const isInvalid = isEmpty || hasExceeded;

      setFilesSelected(
        fileIsNullOrUndefined === false
          ? [...filesRef].map((file) => file.name).join(`, `)
          : null
      );
      setIsError(isInvalid);

      onChange({
        fieldId,
        value: allowMulti === true ? filesRef : fileRef,
        label: fieldLabel,
        isValid: isInvalid === false
      });
    },
    [onChange, fieldId, fieldLabel, required, allowMulti]
  );

  useEffect(() => {
    const acceptedTypes = Object.values(fieldValue)
      .map((item) => {
        return item.state === true ? item.accepted : ``;
      })
      .join();

    setAccepted(acceptedTypes);
    setAllowMulti(fieldValue.allowMulti === true);

    onReady({
      fieldId,
      required
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <FormControl
      mb="3"
      isInvalid={submitAttempted && isError}
      isRequired={required}
    >
      <FormLabel
        id={`field-label-file-${fieldId}-${fieldLabel}`}
        htmlFor={fieldId}
        mb="2"
      >
        {fieldLabel}
      </FormLabel>
      <Box pos="relative">
        <Input
          maxWidth="106px"
          type="file"
          id={fieldId}
          data-custom-data-id={dataId}
          name={allowMulti === true ? `${fieldLabel}[]` : fieldLabel}
          multiple={allowMulti}
          placeholder={defaultPlaceholder}
          p="0"
          border="none"
          borderRadius="0"
          accept={accepted}
          onChange={(event) => handleOnChange(event.target.files)}
        />
        <Box pos="absolute" top="2px" left="7.5rem">
          {filesSelected !== null ? filesSelected : noFileSelectedMessage}
        </Box>
      </Box>
      {submitAttempted && isError && (
        <FormErrorMessage>{errorMessage}</FormErrorMessage>
      )}
    </FormControl>
  );
};

export default FieldComponent;
